import type { Card /* CardType */ } from "@apac/checkout";
import { CardType } from "@hsbc/utilities";

export const hsbcCardMap: Record<string, Card> = {
  491237: {
    type: CardType.CreditCard,
    name: "HSBC Zero Credit Card",
    incentives: [],
  },
  411939: {
    type: CardType.CreditCard,
    name: "HSBC Platinum Select Credit Card",
    incentives: [],
  },
  418348: {
    type: CardType.CreditCard,
    name: "HSBC Cashback Credit Card",
    incentives: [],
  },
  539830: {
    type: CardType.CreditCard,
    name: "HSBC Black Credit Card",
    incentives: [],
  },
  517722: {
    type: CardType.CreditCard,
    name: "HSBC Advance Credit Card",
    incentives: [],
  },
  552102: {
    type: CardType.CreditCard,
    name: "HSBC Premier Credit Card",
    incentives: [],
  },
  491236: {
    type: CardType.CreditCard,
    name: "HSBC Gold Credit Card",
    incentives: [],
  },
  402558: {
    type: CardType.CreditCard,
    name: "HSBC Platinum Credit Card",
    incentives: [],
  },
  407075: {
    type: CardType.CreditCard,
    name: "HSBC Cash+ Credit Card",
    incentives: [],
  },
  407095: {
    type: CardType.CreditCard,
    name: "HSBC Max Rewards Credit Card",
    incentives: [],
  },
  419647: {
    type: CardType.DebitCard,
    name: "HSBC Personal Banking Debit Card",
    incentives: [],
  },
  419648: {
    type: CardType.DebitCard,
    name: "HSBC Advance Debit Card",
    incentives: [],
  },
  419649: {
    type: CardType.DebitCard,
    name: "HSBC Premier Debit Card",
    incentives: [],
  },
  428689: {
    type: CardType.DebitCard,
    name: "HSBC Global Private Banking Debit Card",
    incentives: [],
  },
  428688: {
    type: CardType.DebitCard,
    name: "HSBC Platinum Debit Card",
    incentives: [],
  },
};
